import React from "react";
import { Stack, Typography } from "@mui/material";

import { HubCardStack } from "../HubCardStack";
import { HubIcon } from "../HubIcon";
import DataRateChange from "./DataRateChange";

export const DataRateContainer = ({
  label,
  value,
  rate,
  hideRate = false,
  rateProps = {},
  icon,
  iconAccent = "hubColors.mainFocus",
  iconAccentBg = "hubColors.mainFocusTransparent",
  sublabel,
  rangeLabel,
  valueSx = {},
  ...rest
}) => (
  <HubCardStack padding="12px 14px" gap="6px" {...rest}>
    <Stack direction="row" alignItems="center" gap="8px">
      {icon && (
        <Stack
          sx={{
            width: 22,
            height: 22,
            borderRadius: "50%",
            backgroundColor: iconAccentBg,
            color: iconAccent,
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <HubIcon icon={icon} size="12px" />
        </Stack>
      )}
      <Typography variant="caption11" sx={{ fontWeight: 400 }}>
        {label}
      </Typography>
    </Stack>

    <Stack direction="row" gap="15px" alignItems="center">
      <Typography
        variant="h3"
        sx={{ fontWeight: 700, fontSize: 20, ...valueSx }}
      >
        {value}
      </Typography>
      {!hideRate && <DataRateChange rate={rate} {...rateProps} />}
    </Stack>

    {rangeLabel && (
      <Typography variant="caption" color="text.disabled" fontSize={10}>
        {rangeLabel}
      </Typography>
    )}
  </HubCardStack>
);
